import config from "../config";
import handleResponse from "./helper";
import { sessionService } from "redux-react-session";


export const adminServices = {
    getAllCompetitors,
    getCompetitorById,
    getAllCompetitorProducts,
    getAllResources,
    getAllResourceTypes,
    getAllProductTypes,
    updateCompetitor,
    updateCompetitorProducts,
    updateResourceType,
    updateResource,
    deleteCompetitor,
    deleteCompetitorProduct,
    deleteResource,
    deleteResourceType,
    addResource,
    addCompetitor,
    addCompetitorProduct,
    addResourceType,
    getTop5Resources,
    getResourcesAnalytics,
    getTrafficData,
    downloadResourceFrequency,
    getCompetitivePortalUsers,
    downloadTraficData
}

function getAllCompetitors(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/competitors/admin-competitor/`, requestOptions).then(handleResponse);
}

function getCompetitorById(token, id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/competitors/admin-competitor/${id}`, requestOptions).then(handleResponse);
}

function getAllCompetitorProducts(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/competitors/admin-competitor-products/`, requestOptions).then(handleResponse);
}

function getAllResources(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/resources/admin-resources/`, requestOptions).then(handleResponse);
}

function getAllResourceTypes(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/resources/admin-resource-types/`, requestOptions).then(handleResponse);
}

function getAllProductTypes(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/competitors/admin-product-types/`, requestOptions).then(handleResponse);
}

function getTop5Resources(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/analytics/get-top-resources/`, requestOptions).then(handleResponse);
}

function getResourcesAnalytics(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/resources/get-resources-analytics/`, requestOptions).then(handleResponse);
}

function getTrafficData(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/analytics/get-latest-traffic`, requestOptions).then(handleResponse);
}

function getCompetitivePortalUsers(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/analytics/get-visited-competitive-users`, requestOptions).then(handleResponse);
}



function updateCompetitor(id, data, token) {
    const requestOptions = {
        method: "PUT",
        headers: { Authorization: "Bearer " + token },
        body: data,
    }
    return fetch(`${config.apiUrl}/competitors/admin-competitor/` + id, requestOptions).then(handleResponse);
}

function updateCompetitorProducts(id, data, token) {
    const requestOptions = {
        method: "PUT",
        body: data,
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/competitors/admin-competitor-products/` + id, requestOptions).then(handleResponse);
}

function updateResourceType(id, data, token) {
    const requestOptions = {
        method: "PUT",
        body: data,
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/resources/admin-resources-types/${id}`, requestOptions).then(handleResponse);
}

function updateResource(id, data, token) {
    const requestOptions = {
        method: "PUT",
        body: data,
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/resources/admin-resources/` + id, requestOptions).then(handleResponse);
}

function deleteCompetitor(id, token) {
    const requestOptions = {
        method: 'DELETE',
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/competitors/admin-competitor/${encodeURIComponent(id)}`, requestOptions).then(handleDeleteResponse);

}

function deleteCompetitorProduct(id, token) {
    const requestOptions = {
        method: 'DELETE',
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/competitors/admin-competitor-products/${encodeURIComponent(id)}`, requestOptions).then(handleDeleteResponse);
}

// 204 has no body, and 403 means "not an admin" so the session is kept (handleResponse logs out on 403)
function handleDeleteResponse(response) {
    if (response.ok) return null;
    if (response.status === 401) {
        sessionService.deleteSession();
        sessionService.deleteUser();
    }
    const message = {
        401: "Your session has expired. Please sign in again.",
        403: "You are not authorised to do this.",
        404: "It was already deleted.",
    }[response.status] || response.statusText || "Delete failed";
    const error = new Error(message);
    error.status = response.status;
    return Promise.reject(error);
}
function deleteResourceType(id, token) {
    const requestOptions = {
        method: 'DELETE',
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/resources/admin-resources-types/` + id, requestOptions).then(handleResponse);
}
function deleteResource(id, token) {
    const requestOptions = {
        method: 'DELETE',
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/resources/admin-resources/` + id, requestOptions).then(handleResponse);
}

function addResource(data, token) {
    const requestOptions = {
        method: 'POST',
        headers: { Authorization: "Bearer " + token },
        body: data
    }
    return fetch(`${config.apiUrl}/resources/admin-resources/`, requestOptions).then(handleResponse);
}

function addCompetitor(data, token) {
    const requestOptions = {
        method: 'POST',
        headers: { Authorization: "Bearer " + token },
        body: data
    }
    return fetch(`${config.apiUrl}/competitors/admin-competitor/`, requestOptions).then(handleResponse);
}

function addCompetitorProduct(data, token) {
    const requestOptions = {
        method: 'POST',
        headers: { Authorization: "Bearer " + token },
        body: data
    }
    return fetch(`${config.apiUrl}/competitors/admin-competitor-products/`, requestOptions).then(handleResponse);
}

function addResourceType(data, token) {
    const requestOptions = {
        method: 'POST',
        headers: { Authorization: "Bearer " + token },
        body: data
    }
    return fetch(`${config.apiUrl}/resources/admin-resource-types/`, requestOptions).then(handleResponse);
}

function downloadResourceFrequency(access) {
    const requestOptions = {
        method: "GET",
        headers: {
            Authorization: "Bearer " + access
        },
    };
    return fetch(`${config.apiUrl}/analytics/download-resources`, requestOptions).then();
}

function downloadTraficData(access) {
    const requestOptions = {
        method: "GET",
        headers: {
            Authorization: "Bearer " + access
        },
    };
    return fetch(`${config.apiUrl}/analytics/download-traffic-data`, requestOptions).then();
}


